export const ALLOWED_IMAGE_TYPES = ["image/jpeg", "image/png", "image/gif"];

export const IMAGE_ACCEPT = ".jpg,.jpeg,.png,.gif,image/jpeg,image/png,image/gif";

export const DEFAULT_IMAGE_SIZE_LIMIT = 10 * 1024 * 1024;

export function validateImageFile(file, sizeLimit = DEFAULT_IMAGE_SIZE_LIMIT) {
  if (!file) {
    return "请选择图片";
  }
  if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
    return "仅支持 JPG、PNG、GIF 图片";
  }
  if (file.size > sizeLimit) {
    return `图片大小不可超过 ${sizeLimit / 1024 / 1024} MB`;
  }
  return "";
}
